import { useMemo } from 'react';

import { ChartOfAccountsView } from '@futrli/views/ChartOfAccountsView';
import { useApiView } from '@futrli/views/hooks/useApiView';

export const useCoaApiView = (workspaceId: string, organisationId: string) => {
  const view = useApiView(
    useMemo(() => new ChartOfAccountsView(workspaceId, organisationId), [workspaceId, organisationId])
  );

  return {
    ...view.state,
    createGroupAndUpdateStructure: view.createGroupAndUpdateStructure.bind(view),
    saveReorderedTree: view.saveReorderedTree.bind(view),
    deleteCoaGroup: view.deleteGroup.bind(view),
    updateGroup: view.updateGroup.bind(view),
    updateStructure: view.updateStructure.bind(view),
    recategoriseAccount: view.recategoriseAccount.bind(view),
    setSwitchRule: view.setSwitchRule.bind(view),
    deleteSwitchRule: view.deleteSwitchRule.bind(view)
  };
};
